<div class="mm-searcher">
	<div class="mm-searcher__toolbar">
		<button mat-raised-button color="accent" type="button" (click)="emitMM()">
			<mat-icon>save</mat-icon>
			Save mix &amp; match rules
		</button>
	</div>

	<div class="mm-searcher__filters">
		<div class="filter-checkgroup" *ngIf="brands?.length">
			<div class="filter-checkgroup__header">
				<span class="filter-checkgroup__title" id="mm-filter-brand-label">Brand</span>
				<span class="filter-checkgroup__count" *ngIf="brand.value?.length">{{ brand.value.length }} selected</span>
				<div class="filter-checkgroup__actions" role="group" aria-label="Brand bulk selection">
					<button type="button" class="filter-checkgroup__action" (click)="selectAllBrands()">All</button>
					<button type="button" class="filter-checkgroup__action" (click)="selectNoneBrands()">None</button>
				</div>
			</div>
			<div class="filter-checkgroup__list" role="group" aria-labelledby="mm-filter-brand-label">
				<label *ngFor="let k of brands" class="filter-check">
					<input type="checkbox" [checked]="isBrandSelected(k.manufacturer_id)" (change)="onBrandCheckboxChange(k.manufacturer_id, $event)">
					<span class="filter-check__text">{{ k.name }}</span>
				</label>
			</div>
		</div>

		<div class="filter-checkgroup" *ngIf="categories?.length">
			<div class="filter-checkgroup__header">
				<span class="filter-checkgroup__title" id="mm-filter-cat-label">Category</span>
				<span class="filter-checkgroup__count" *ngIf="category.value?.length">{{ category.value.length }} selected</span>
				<div class="filter-checkgroup__actions" role="group" aria-label="Category bulk selection">
					<button type="button" class="filter-checkgroup__action" (click)="selectAllCategories()">All</button>
					<button type="button" class="filter-checkgroup__action" (click)="selectNoneCategories()">None</button>
				</div>
			</div>
			<div class="filter-checkgroup__list" role="group" aria-labelledby="mm-filter-cat-label">
				<label *ngFor="let c of categories" class="filter-check">
					<input type="checkbox" [checked]="isCategorySelected(c.categoryid)" (change)="onCategoryCheckboxChange(c.categoryid, $event)">
					<span class="filter-check__text">{{ c.categorydescription }}</span>
				</label>
			</div>
		</div>

		<div class="filter-checkgroup" *ngIf="productlines?.length">
			<div class="filter-checkgroup__header">
				<span class="filter-checkgroup__title" id="mm-filter-pl-label">Product line</span>
				<span class="filter-checkgroup__count" *ngIf="productLine.value?.length">{{ productLine.value.length }} selected</span>
				<div class="filter-checkgroup__actions" role="group" aria-label="Product line bulk selection">
					<button type="button" class="filter-checkgroup__action" (click)="selectAllProductLines()">All</button>
					<button type="button" class="filter-checkgroup__action" (click)="selectNoneProductLines()">None</button>
				</div>
			</div>
			<div class="filter-checkgroup__list" role="group" aria-labelledby="mm-filter-pl-label">
				<label *ngFor="let p of productlines" class="filter-check">
					<input type="checkbox" [checked]="isProductLineSelected(p.line_field)" (change)="onProductLineCheckboxChange(p.line_field, $event)">
					<span class="filter-check__text">{{ p.line_description }}</span>
				</label>
			</div>
		</div>
	</div>

	<div class="mm-searcher__row mm-searcher__row--range">
		<div class="promo-field">
			<label class="promo-field__label" for="mm-range-start">Range start</label>
			<input id="mm-range-start" class="promo-input" type="text" autocomplete="off" [formControl]="rangestart" (input)="search()" (keydown.enter)="$event.preventDefault()">
		</div>
		<div class="promo-field">
			<label class="promo-field__label" for="mm-range-end">Range end</label>
			<input id="mm-range-end" class="promo-input" type="text" autocomplete="off" [formControl]="rangeend" (input)="search()" (keydown.enter)="$event.preventDefault()">
		</div>
	</div>

	<div class="promo-field mm-searcher__keywords">
		<label class="promo-field__label" for="mm-keywords">Specific item</label>
		<input id="mm-keywords" class="promo-input" type="search" autocomplete="off" [formControl]="keywords" (keydown.enter)="$event.preventDefault()" placeholder="Part # — results appear below">
	</div>

	<div class="promo-table-wrap mm-searcher__kw-results" *ngIf="keywordresults?.length">
		<table class="promo-table promo-table--compact">
			<thead>
				<tr>
					<th>Item #</th>
					<th>Description</th>
					<th class="actions-col"></th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let r of keywordresults" class="mm-searcher__click-row">
					<td class="stockid-cell">{{ r.stockid }}</td>
					<td>{{ r.description }}</td>
					<td class="row-actions">
						<button type="button" class="mm-searcher__link-btn" (click)="addMMItem(r)">Add</button>
					</td>
				</tr>
			</tbody>
		</table>
	</div>

	<div class="mm-searcher__section" *ngIf="selectedproducts?.length">
		<h3 class="mm-searcher__section-title">Selected items</h3>
		<div class="promo-table-wrap">
			<table class="promo-table promo-table--compact">
				<thead>
					<tr>
						<th>Item #</th>
						<th>Description</th>
						<th class="actions-col"></th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let r of selectedproducts">
						<td class="stockid-cell">{{ r.stockid }}</td>
						<td>{{ r.description }}</td>
						<td class="row-actions">
							<button type="button" class="mm-searcher__link-btn mm-searcher__link-btn--danger" (click)="removeItem(r)">Remove</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<div class="mm-searcher__section" *ngIf="results?.length">
		<h3 class="mm-searcher__section-title">Items affected</h3>
		<div class="promo-table-wrap">
			<table class="promo-table">
				<thead>
					<tr>
						<th>Item #</th>
						<th>Description</th>
						<th>DWO</th>
						<th>Discontinued</th>
						<th class="text-right">QOH</th>
						<th class="actions-col"></th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let p of results">
						<td class="stockid-cell">{{ p.stockid }}</td>
						<td>{{ p.description }}</td>
						<td>{{ p.dwo }}</td>
						<td>{{ p.discontinued }}</td>
						<td class="text-right">{{ p.locstock }}</td>
						<td class="row-actions">
							<button type="button" class="mm-searcher__link-btn mm-searcher__link-btn--danger" (click)="exludeItem(p)">Exclude</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<div class="mm-searcher__section" *ngIf="exclusions?.length">
		<h3 class="mm-searcher__section-title">Exclusions</h3>
		<div class="promo-table-wrap">
			<table class="promo-table promo-table--compact">
				<thead>
					<tr>
						<th>Item #</th>
						<th>Description</th>
						<th class="actions-col"></th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let p of exclusions">
						<td class="stockid-cell">{{ p.stockid }}</td>
						<td>{{ p.description }}</td>
						<td class="row-actions">
							<button type="button" class="mm-searcher__link-btn mm-searcher__link-btn--danger" (click)="removeExclusion(p)">Remove</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>
